import {Component, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {FieldConfig} from "../../../interfaces/field.interface";

@Component({
    selector: "app-button",
    templateUrl: './button.component.html',
    styles: []
})
export class ButtonComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;
    public hideMe = false;

    constructor() {
    }

    callBackAction(e: any) {
        this.field.callBackEvent(e);
    }

    ngOnInit() {
        // if (this.field.value && this.field.inputType === 'color') {
        //     this.group.controls[this.field.name]?.setValue(this.field.value);
        //     this.color = this.field.value;
        // }
    }
}
